__turbopack_context__.v({
  "banner": "PACySG_banner",
  "banner-bg-info": "PACySG_banner-bg-info",
  "banner-bg-success": "PACySG_banner-bg-success",
  "close-button": "PACySG_close-button",
  "content": "PACySG_content",
  "placeholder": "PACySG_placeholder",
});
